import { Link } from 'react-router-dom'

import { useDocumentTitle } from '@/frontend/hooks/use-document-title'

export function NotFoundPage() {
  useDocumentTitle('Page Not Found')
  return (
    <div className="text-center">
      <h1 className="text-headline-lg mb-6">404</h1>
      <p className="text-xl text-muted-foreground mb-4">Page not found</p>
      <Link to="/" className="text-primary hover:underline">
        Go back home
      </Link>
    </div>
  )
}
